import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';

function Login() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const data = await login(email, password);
      // Redirect based on role
      if (data.user.role === 'admin') {
        navigate('/admin');
      } else {
        navigate('/dashboard');
      }
    } catch (err) {
      setError(err.message || t('auth.login.error'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <img
          src="https://customer-assets.emergentagent.com/job_f48ed865-f137-40ec-8ec5-750617ca0014/artifacts/jm5y5oub_logo.png"
          alt="ZENTA Logo"
          className="auth-logo"
        />
        <h1 className="auth-title">ZENTA</h1>
        <p className="auth-subtitle">{t('auth.login.subtitle')}</p>

        {error && <div className="error-message" data-testid="error-message">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">{t('auth.login.email')}</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="email-input"
              placeholder={t('auth.login.emailPlaceholder')}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">{t('auth.login.password')}</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={6}
              data-testid="password-input"
              placeholder={t('auth.login.passwordPlaceholder')}
            />
          </div>

          <button
            type="submit"
            className="btn-primary"
            disabled={loading}
            data-testid="login-button"
          >
            {loading ? t('common.loading') : t('auth.login.submit')}
          </button>
        </form>

        <div className="auth-link">
          <Link to="/forgot-password" data-testid="forgot-password-link">
            {t('auth.login.forgotPassword')}
          </Link>
        </div>

        <div className="auth-link">
          {t('auth.login.noAccount')}{' '}
          <Link to="/register" data-testid="register-link">{t('auth.login.registerNow')}</Link>
        </div>
      </div>
    </div>
  );
}

export default Login;
